module.exports = __webpack_public_path__ + "media/images/img-wizard-8d783e3708aa0346377e28a857339c6a.svg";